import { ref } from 'vue';

const isMobile = ref<boolean>();

const setDevice = () => {
    isMobile.value = window.innerWidth < 992;
};

setDevice();

window.addEventListener('resize', setDevice);

export const useDevice = () => ({
    isMobile: isMobile.value,
});
